"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateKeyPair = generateKeyPair;
exports.signJWT = signJWT;
exports.verifyJWT = verifyJWT;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var ed25519 = _interopRequireWildcard(require("@stablelib/ed25519"));

var _random = require("@stablelib/random");

var _time = require("@walletconnect/time");

var _constants = require("./constants");

var _utils = require("./utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function generateKeyPair() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _random.randomBytes)(_constants.KEY_PAIR_SEED_LENGTH);
  return ed25519.generateKeyPairFromSeed(seed);
}

function signJWT(_x, _x2, _x3, _x4) {
  return _signJWT.apply(this, arguments);
}

function _signJWT() {
  _signJWT = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(sub, aud, ttl, keyPair) {
    var iat,
        header,
        iss,
        exp,
        payload,
        data,
        signature,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            iat = _args.length > 4 && _args[4] !== undefined ? _args[4] : (0, _time.fromMiliseconds)(Date.now());
            header = {
              alg: _constants.JWT_IRIDIUM_ALG,
              typ: _constants.JWT_IRIDIUM_TYP
            };
            iss = (0, _utils.encodeIss)(keyPair.publicKey);
            exp = iat + ttl;
            payload = {
              iss: iss,
              sub: sub,
              aud: aud,
              iat: iat,
              exp: exp
            };
            data = (0, _utils.encodeData)({
              header: header,
              payload: payload
            });
            signature = ed25519.sign(keyPair.secretKey, data);
            return _context.abrupt("return", (0, _utils.encodeJWT)({
              header: header,
              payload: payload,
              signature: signature
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _signJWT.apply(this, arguments);
}

function verifyJWT(_x5) {
  return _verifyJWT.apply(this, arguments);
}

function _verifyJWT() {
  _verifyJWT = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(jwt) {
    var _decodeJWT, header, payload, data, signature, publicKey;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _decodeJWT = (0, _utils.decodeJWT)(jwt), header = _decodeJWT.header, payload = _decodeJWT.payload, data = _decodeJWT.data, signature = _decodeJWT.signature;

            if (!(header.alg !== _constants.JWT_IRIDIUM_ALG || header.typ !== _constants.JWT_IRIDIUM_TYP)) {
              _context2.next = 3;
              break;
            }

            throw new Error("JWT must use EdDSA algorithm");

          case 3:
            publicKey = (0, _utils.decodeIss)(payload.iss);
            return _context2.abrupt("return", ed25519.verify(publicKey, data, signature));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _verifyJWT.apply(this, arguments);
}